import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import Error from '../../../components/errors/Error';
import BtnContent from '../../../components/buttons/BtnContent';
import CardButtonProcess from '../../../components/cards/CardButtonProcess';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import { FaGears } from 'react-icons/fa6';
import { FaExclamationCircle } from 'react-icons/fa';
//SLICE

import { chageStatePeriodsThunk, getConfigsThunk, initialStateConfig } from '../../../store/slices/catalogs/config.slice';
import { API_BASE_URL } from '../../../store/constans';
import { formatMonthYear } from '../../../utils/funtions';
import { Link } from 'react-router-dom';

const ConfigurationsView = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, message, error } = useSelector(state => state.configurations);
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        dispatch(getConfigsThunk());
        return () => {
            dispatch(initialStateConfig())
        }
    }, []);

    const handleChangeStateProcess = (value) => {
        const data = { enableRegistrationProcess: value }
        dispatch(chageStatePeriodsThunk(items[0].id, data));
    }

    const handleChangeStateSpaceProcess = (value) => {
        const data = { enableReservationSpaceProcess: value }
        dispatch(chageStatePeriodsThunk(items[0].id, data));
    }

    if (message === "Registro actualizado correctamente ") {
        dispatch(getConfigsThunk());
    }

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <HeaderForm title={t("Configuración general")} />
                    <div className="flex items-center justify-center h-[90%]">
                        {items.length > 0 ?
                            <div className='grid grid-cols-1 md:grid-cols-3 w-full h-full gap-2'>
                                <div className="bg-base-100 rounded-2xl shadow-md p-6 flex flex-col items-center justify-center text-center">
                                    <div className=" mb-4">
                                        <img src={API_BASE_URL + items[0].logo} alt="Logo Colegio" className='w-[250px]' />
                                    </div>
                                    <h2 className="text-xl font-bold">{items[0].name}</h2>
                                    <p className="text-sm text-gray-500">Establecimiento educativo</p>
                                    <div className="mt-4 text-left w-full text-sm text-gray-700 space-y-1">
                                        <p><strong>Rector/a:</strong> {items[0].director}</p>
                                        <p><strong>Dirección:</strong> {items[0].address}</p>
                                        <p><strong>RUC:</strong> {items[0].phone}</p>
                                        <p><strong>Año lectivo en curso:</strong> {formatMonthYear(items[0].fecha_inicio_periodo_actual) + ' - ' + formatMonthYear(items[0].fecha_fin_periodo_actual)}</p>
                                        <p><strong>Siguiente Año lectivo:</strong> {formatMonthYear(items[0].fecha_inicio_periodo_siguiente) + ' - ' + formatMonthYear(items[0].fecha_fin_periodo_siguiente)}</p>
                                    </div>
                                    <div className="mt-4">
                                        <Link to={`/panel/configurations/${items[0].id}`} className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-1 rounded-md shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out">
                                            Editar Información
                                        </Link>
                                    </div>
                                </div>
                                <div className="bg-base-100 rounded-2xl shadow-md p-6 flex flex-col justify-center">
                                    <div>
                                        <h3 className="text-lg font-bold mb-2">🗓️ Periodo Reserva de Cupo</h3>
                                        <p className="text-sm text-gray-600">{formatMonthYear(items[0].fecha_inicio_reservacion_cupo) + ' - ' + formatMonthYear(items[0].fecha_fin_reservacion_cupo)}</p>
                                        <div className={`${items[0].habilitar_reservacion_cupo ? ' badge-success' : 'badge-error'} text-white badge mt-2`}>{items[0].habilitar_reservacion_cupo ? 'Habilitado' : 'No habilitado'}</div>
                                    </div>
                                    <div className="mt-6 space-y-2">
                                        {
                                            items[0].habilitar_reservacion_cupo ?
                                                <div className='flex gap-2 text-start items-center justify-center p-2 bg-yellow-200'>
                                                    <p className='flex items-center text-sm p-2 gap-2'> <FaExclamationCircle size={30} />Para configurar un nuevo periodo debe deshabilitar el proceso de reservación de cupo</p>
                                                </div>
                                                :
                                                <BtnContent type="button" to={`/panel/configurations/space_period/${items[0].id}`}>{t("Configurar periodo")}</BtnContent>
                                        }
                                        {
                                            items[0].habilitar_reservacion_cupo ?
                                                <BtnContent type="funtion" funtion={() => handleChangeStateSpaceProcess(false)}>{t("Deshabilitar reserva de cupo")}</BtnContent>
                                                :
                                                <BtnContent type="funtion" funtion={() => handleChangeStateSpaceProcess(true)}>{t("Habilitar reserva de cupo")}</BtnContent>
                                        }
                                    </div>
                                </div>
                                <div className="bg-base-100 rounded-2xl shadow-md p-6 flex flex-col justify-center">
                                    <div>
                                        <h3 className="text-lg font-bold mb-2">🗓️ Periodo Matriculación en línea</h3>
                                        <p className="text-sm text-gray-600">{formatMonthYear(items[0].fecha_inicio_matriculacion) + ' - ' + formatMonthYear(items[0].fecha_fin_matriculacion)}</p>
                                        <div className={`${items[0].habilitar_proceso_matriculacion ? ' badge-success' : 'badge-error'} text-white badge mt-2`}>{items[0].habilitar_proceso_matriculacion ? 'Habilitado' : 'No habilitado'}</div>
                                    </div>
                                    <div className="mt-6 space-y-2">
                                        {
                                            items[0].habilitar_proceso_matriculacion ?
                                                <div className='flex gap-2 text-start items-start justify-center p-2 bg-yellow-200'>
                                                    <p className='flex items-center text-sm p-2 gap-2'> <FaExclamationCircle size={30} />Para configurar un nuevo periodo debe deshabilitar el proceso de matriculación primero</p>
                                                </div>
                                                :
                                                <BtnContent type="button" to={`/panel/configurations/matriculation_period/${items[0].id}`}>{t("Configurar periodo")}</BtnContent>
                                        }
                                        {
                                            items[0].habilitar_proceso_matriculacion ?
                                                <BtnContent type="funtion" funtion={() => handleChangeStateProcess(false)}>{t("Deshabilitar matriculación en línea")}</BtnContent>
                                                :
                                                <BtnContent type="funtion" funtion={() => handleChangeStateProcess(true)}>{t("Habilitar matriculación en línea")}</BtnContent>
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            <CardButtonProcess title={'Crear nueva configuración general'} background={'bg-slate-100'} to={`/panel/configurations/new_configuration`} >
                                <FaGears size={60} color='green' />
                            </CardButtonProcess>
                        }
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default ConfigurationsView;
